module.exports = __webpack_public_path__ + "static/media/sys_pic.6b2773a3.png";